/** 12840 → "$128.40". Top-ups are always in dollars; other amounts go through usePrefs().money. */
export function formatUsd(cents: number): string {
  const abs = Math.abs(cents);
  const whole = Math.floor(abs / 100).toLocaleString('en-US');
  const frac = String(abs % 100).padStart(2, '0');
  return `${cents < 0 ? '−' : ''}$${whole}.${frac}`;
}

/** "50", "50.5", "50,25" → cents; anything else → null */
export function parseUsdInput(value: string): number | null {
  const m = /^(\d{1,6})(?:[.,](\d{0,2}))?$/.exec(value.trim());
  if (!m) return null;
  return Number(m[1]) * 100 + Number((m[2] ?? '').padEnd(2, '0'));
}
